import { render, staticRenderFns } from "./user-menu-8v.vue?vue&type=template&id=2e63d272&"
import script from "./user-menu-8v.vue?vue&type=script&lang=js&"
export * from "./user-menu-8v.vue?vue&type=script&lang=js&"
import style0 from "./user-menu-8v.vue?vue&type=style&index=0&id=2e63d272&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports